import { useEffect } from "react";

import { useQuery, useQueryClient } from "@tanstack/react-query";

import { refreshSession } from "@/api/client";
import { adminApi, authApi } from "@/api/endpoints";
import { queryKeys } from "@/configs/query-keys";
import { useAuthStore } from "@/store/auth";

/**
 * Sahifa ochilganda sessiyani refresh cookie orqali tiklashga bir marta
 * urinadi. `refreshSession` bitta parvozli — StrictMode ikki marta chaqirsa
 * ham so'rov bitta ketadi.
 */
export function useSessionBootstrap(): boolean {
  const bootstrapped = useAuthStore(s => s.bootstrapped);
  useEffect(() => {
    if (bootstrapped) return;
    refreshSession()
      .catch(() => useAuthStore.getState().clear())
      .finally(() => useAuthStore.getState().markBootstrapped());
  }, [bootstrapped]);
  return bootstrapped;
}

/** Joriy foydalanuvchi adminmi — backend `ADMIN_TELEGRAM_IDS` bo'yicha hal qiladi. */
export function useAdminMe(enabled: boolean) {
  return useQuery({ queryKey: queryKeys.me, queryFn: adminApi.me, enabled, staleTime: 60_000 });
}

/** Chiqish: cookie backend'da o'chadi, kesh tozalanadi. */
export function useLogout() {
  const queryClient = useQueryClient();
  return async () => {
    try {
      await authApi.logout();
    } catch {
      // Tarmoq xatosi bo'lsa ham mahalliy sessiya yopiladi.
    }
    useAuthStore.getState().clear();
    queryClient.clear();
  };
}
